/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InvestorsResponseDto } from '../../models/investors-response-dto';

export interface AdminInsightsControllerGetInvestorsV1$Params {

/**
 * Time period for aggregation (default: monthly)
 */
  period?: 'weekly' | 'monthly' | 'yearly';
}

export function adminInsightsControllerGetInvestorsV1(http: HttpClient, rootUrl: string, params?: AdminInsightsControllerGetInvestorsV1$Params, context?: HttpContext): Observable<StrictHttpResponse<InvestorsResponseDto>> {
  const rb = new RequestBuilder(rootUrl, adminInsightsControllerGetInvestorsV1.PATH, 'get');
  if (params) {
    rb.query('period', params.period, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<InvestorsResponseDto>;
    })
  );
}

adminInsightsControllerGetInvestorsV1.PATH = '/v1/admin/insights/investors';
